import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_mrmtrade.png",
      alt: "Estratégias MRM Trade",
    },
    title: "MRM Trader Bots",

    // String ou array de strings
    text: "Robôs para negociação de ativos da B3 com alta performance com inúmeras ferramentas de segurança para minimizar riscos.",
    testimonial: {
      text: "Inteligência artificial ao alcance de todos",
      author: {
        name: "João Roberto., Head de tecnologia da MRM Trade",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias",
    heading: "Teste e negocie com nossas estratégias.",
    subtitle:
      "Estratégias testadas e otimizadas com os melhores parâmetros para realizar os melhores lucros do mercado com stops pre-defindos mantendo todas as negociações dentro da sua margem de risco.",
  },

  cta: {
    title: "Faça um teste e veja como é tranquilo",
    subtitle: "e seguro negociar com nossos robôs.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A MRM",
    col1: [
      "Somos especialistas em negociação automatizada para mercado financeiro com mais de 10 anos de experiencia investindo com tecnologia e segurança nas operações.",
      "Nossos robôs permitem uma pre-definição para limitação de perdas por operação, perdas diárias máximas.",
    ],
    col2: [
      "Uma vez alcançado seu objetivo o robô para de operar evitando devolver seus lucros para o mercado.",
      "Negociação com disciplina, velocidade e segurança é o nosso lema.",
    ],
  },

  stats: {
    title: "Um pouco sobre nossa Empresa em números",
    subtitle: "10 anos de experiência com negociação automatizada",
    data: [
      {
        value: "+10",
        description: "Anos em atividade.",
      },
      {
        value: "+1k",
        description: "Clientes satisfeitos.",
      },
      {
        value: "+1M",
        description: "Ordens executadas por ano.",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da MRM Trade?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Algoritmos rodando em servidores próximos aos servidores da B3 gerando tempo de resposta mais rápido",
      },
      {
        icon: iconsSet.handshake,
        title: "Confiança",
        description:
          "Deixe nossos robôs trabalhar por você e ganhe tempo e conforto",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description: "Suporte total durante todo tempo do pregão.",
      },
      {
        icon: iconsSet.favorite,
        title: "Eficiência",
        description:
          "usando a lógica, deixe a emoção de lado, utilizando algoritmos de alta complexidade para fazer todas as análises necessárias.",
      },

      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Ganhei tempo e dinheiro quando parei de negociar pessoalmente na bolsa e comecei a utilizar robôs.",
      author: "André Barreto ",
      job: "Médico",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Eu não tinha disciplina para acompanhar o mercado diariamente, agora eu acompanho no máximo 1 vez por dia e vejo meus resultados",
      author: "Camila Andrade",
      job: "Engenheira Química",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
